import {BindWalletParam, ModalWithHeaderProps} from "../../types/types";
import {ModalWithHeader} from "../../ui/Modal";
import React, {useEffect, useState} from "react";
import {getWalletInitApi, getWalletNonceApi, loginByWalletApi, toBindWalletApi} from "../../api";
import {isSuccess} from "../../api/request";
import matchlog from "../../utils/matchlog";
import {useMatch} from "../../MatchContext";
import eventManager from "../../hooks/eventManager";
import {useIntl} from "react-intl";
import WalletModalContent from "../WalletModalContent";
import {
    TonConnectUIProvider,
    useTonAddress,
    useTonConnectModal,
    useTonConnectUI,
    useTonWallet,
} from '@tonconnect/ui-react';
import useLocalStore from "../../store/useLocalStore";

function WalletContent({
                           onSuccess,
                           type,
                       }: {
    onSuccess?: () => void
    type: 'login' | 'bind' | ''
}) {
    const {events, login} = useMatch()
    const [connected, setConnected] = useState(false);
    const wallet = useTonWallet();
    const userFriendlyAddress = useTonAddress();
    const [tonConnectUI] = useTonConnectUI();
    const {state, open, close} = useTonConnectModal();
    const [status, setStatus] = useState<'' | 'nonce' | 'signer' | 'success' | 'error'>('')
    const statusRef = React.useRef(status)
    const [error, setError] = useState('')


    useEffect(() => {
        const init = async () => {
            if (tonConnectUI.connected) {
                await tonConnectUI.disconnect();
            }
            open()
        };
        init();
        tonConnectUI.onStatusChange(wallet => {
            matchlog.log('onStatusChange:', wallet, wallet?.connectItems?.tonProof, JSON.stringify(wallet?.connectItems?.tonProof));
            if (wallet?.connectItems?.tonProof && 'proof' in wallet!.connectItems.tonProof) {
                matchlog.log(wallet?.connectItems.tonProof.proof, wallet?.account);
                const toLoginInWallet = async () => {
                    if (statusRef.current || !wallet) return
                    setStatus('signer')
                    statusRef.current = 'signer'
                    try {
                        const signature = {
                            "address": wallet?.account?.address,
                            "network": wallet?.account?.chain,
                            "public_key": wallet?.account?.publicKey,
                            "proof": {
                                //@ts-ignore
                                ...wallet?.connectItems?.tonProof?.proof,
                                "state_init": wallet?.account?.walletStateInit
                            }
                        }
                        let obj: BindWalletParam = {
                            type: 'TON',
                            address: wallet?.account?.publicKey as string,
                            signature: JSON.stringify(signature),
                            //@ts-ignore
                            message:wallet?.connectItems?.tonProof?.proof.payload,
                            connector_type: "TON",
                            wallet_client_type: wallet?.name
                        }
                        console.log('signature', {
                            signature,
                            obj
                        })

                        const res1 = type == 'bind' ? await toBindWalletApi(obj) : await loginByWalletApi(obj)
                        if (res1) {
                            if (!isSuccess(res1)) {
                                throw new Error(res1.message)
                            }
                            matchlog.log(res1)
                            setStatus('success')
                            statusRef.current = 'success'
                            if (type == 'bind') {
                                events!.onBind && events!.onBind({
                                    type: 'ton'
                                })
                                eventManager.emit('onBind', {
                                    type: 'ton'
                                })
                            } else {
                                await login({
                                    // mid: res1.data.mid,
                                    token: `${res1.data.token_type} ${res1.data.access_token}`
                                })
                            }
                            onSuccess && onSuccess()
                        }

                    } catch (error: any) {
                        // toast.error(error.message)
                        // disconnect()
                        setStatus('error')
                        setError(error.message)
                        statusRef.current = ''
                    }
                }
                toLoginInWallet()
            }
        })
    }, []);
    useEffect(() => {
        if (wallet) {
            setConnected(true);
            console.log('Wallet connected:', wallet);
        } else {
            setConnected(false);
            open()
            statusRef.current = ''
            setStatus('')
        }
    }, [wallet]);

    useEffect(() => {
        console.log({
            state,
            wallet
        })
        if (state.status=='opened') {
            const init = async () => {
                tonConnectUI.setConnectRequestParameters({state: 'loading'});
                const res = type == 'bind' ? await getWalletInitApi({
                    address: "tonconnect",
                    type: "TON"
                }) : await getWalletNonceApi({address: "tonconnect", type: "TON"});
                if (!isSuccess(res)) {
                    tonConnectUI.setConnectRequestParameters(null);
                    throw new Error(res.message)
                }
                tonConnectUI.setConnectRequestParameters({
                    state: "ready",
                    value: {tonProof: res.data.nonce}
                });
            };
            init();
        }else{
            if(!wallet){
                setStatus('')
                statusRef.current = ''
            }
        }
    }, [state]);


    return <WalletModalContent
        connected={connected}
        disconnect={tonConnectUI.disconnect}
        address={userFriendlyAddress}
        visible={state.status=='opened'}
        setVisible={async(v)=>{
            console.log('setVisible',v)

            if(v){
                if (tonConnectUI.connected) {
                    await tonConnectUI.disconnect();
                }
                setStatus('')
                statusRef.current = ''
                open()
            }else{
                close()
            }
        }}
        error={error}
        setError={setError}
        status={status}
    />
}
type TonModalProps = ModalWithHeaderProps & {
    type?: 'login' | 'bind' | ''
    onSuccess?: () => void
}
function TONConnectModal({
                                     type = 'login',
                                     onSuccess,
                                     ...props
                                 }: TonModalProps) {
    const intl = useIntl()
    const {endpoints, appid} = useLocalStore()
    const manifestUrl = `${endpoints.back}api/v1/wallet/ton?appid=${appid}&url=` + encodeURIComponent(window.location.origin)
    return <ModalWithHeader {...props} title={props.title || (intl.formatMessage({
        id: type == "bind" ? "bindWith" : "loginWith"
    }, {
        name: "TON"
    }))}>

        <TonConnectUIProvider
            manifestUrl={manifestUrl}>
            <WalletContent onSuccess={onSuccess} type={type}/>
        </TonConnectUIProvider>
    </ModalWithHeader>
}
export default function TONModal(props: TonModalProps) {
    return props.isOpen && <TONConnectModal {...props}/>
}